import {
  // MinusCircleOutlined,
  PlusOutlined,
  // SearchOutlined,
  // UploadOutlined,
  // CaretDownFilled,
  DeleteFilled,
  // SaveOutlined,
  // EditOutlined
} from "@ant-design/icons";
import {
  Button,
  // Col,
  Form,
  Input,
  // InputNumber,
  // Row,
  Select,
  Space,
  // Typography,
  // Divider,
  // DatePicker,
  Table,
  Tooltip,
  Card
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, {
  useState,
  useEffect,
  useCallback,
  // useRef,
  // useContext
} from "react";
import {
  getListDepartments,
  getListDivisions,
  // getListProjectByYear
} from "../../../../services/progressPerformance";
import { SUCCESS_CODE } from "../../../../lib/const";
import { useNavigate } from "react-router-dom";
// import { set } from "react-hook-form";

// const { Title } = Typography;
// const dateFormat = "DD/MM/YYYY";
// const { RangePicker } = DatePicker;
// const { Text } = Typography;
const { Option } = Select;

const TableNameList = (props) => {
  const navigate = useNavigate();

  const {
    //TABLELIST
    dataSource,
    editingRow,
    handleAdd,
    handleEdit,
    onSaveTable,
    handleDeleteReccord,
    statusBT,
    tableAction,
    canEdit,
    canView,
    year,
    listProject
  } = props;
  const [form] = Form.useForm();
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);

  // const handleChangedDepartment = (value, key, record, index) => {
  //   console.log("-value-", value, key, record, index);
  // };

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  // const fetchListDivisions = useCallback(async (depart) => {
  //   try {
  //     const res = await getListDivisions(depart);

  //     if (res.data.code === SUCCESS_CODE) {
  //       let result_data = res.data.objectValue;
  //       setDropDownDivision(result_data);
  //     }
  //   } catch (error) {}
  // }, []);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  const columns = [
    {
      title: "ชื่อโครงการ",
      dataIndex: "projectId",
      key: "projectId",
      width: 350,
      render: (projectId, record, index) => {
        if (canView === true || record.projectAction === "NONE") {
          return (
            <Form.Item label="">
              {record?.projectNameTh ? record.projectNameTh : "-"}
            </Form.Item>
          );
        } else {
          return (
            <Form.Item
              label=""
              name={[record.key, "projectId"]}
              rules={[
                {
                  required: true,
                  message: "โปรดระบุ"
                }
              ]}
            >
              <Select
                allowClear
                style={{
                  width: "100%"
                }}
                placeholder="กรุณาเลือก"
                // value={record?.projectId}
                onChange={(value, key) => handleEdit(value, record.key, "projectId")}
                disabled={record.projectAction === "NONE"}
              >
                {listProject.map((option) => (
                  <Option value={option.projectId}>
                    {option.projectNameTh}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          );
        }
      }
    },
    {
      title: "ฝ่าย",
      dataIndex: "departmentId",
      key: "departmentId",
      width: 300,
      render: (el, record, index) => {
        if (canView === true) {
          return (
            <Form.Item label="">
              {record?.departmentNameTh ? record.departmentNameTh : "-"}
            </Form.Item>
          );
        } else {
          return (
            <Input
              placeholder="กรุณากรอกข้อมูล"
              value={record.departmentNameTh}
              disabled
            />
          );
        }
      }
    },
    {
      title: "กอง",
      dataIndex: "divisionId",
      key: "divisionId",
      width: 300,
      render: (el, record, index) => {
        if (canView === true) {
          return (
            <Form.Item label="">
              {record?.divisionNameTh ? record.divisionNameTh : "-"}
            </Form.Item>
          );
        } else {
          return (
            <Input
              placeholder="กรุณากรอกข้อมูล"
              value={record.divisionNameTh}
              disabled
            />
          );
        }
      }
    },
    {
      title: "",
      dataIndex: "sequence",
      key: "sequence",
      width: canEdit ? 150 : 0,
      render: (_, record) => {
        if (canEdit) {
          if (editingRow === record.key) {
            return (
              <>
                <Space>
                  <Tooltip
                    title="ลบ"
                    color={"#31343A"}
                    key={"delete"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      style={{ backgroundColor: "#FDE7E5", border: "none" }}
                      onClick={() => handleDeleteReccord(record)}
                    >
                      <DeleteFilled style={{ color: "#F04438" }} />
                    </Button>
                  </Tooltip>
                </Space>
              </>
            );
          } else {
            return (
              <>
                <Space>
                  {/* <Tooltip
                    title="แก้ไข"
                    color={"#31343A"}
                    key={"edit"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      icon={<EditOutlined style={{ color: "#F79009" }} />}
                      style={{ backgroundColor: "#FEF1DF", border: "none" }}
                      onClick={() => handleEdit(record)}
                    ></Button>
                  </Tooltip> */}

                  <Tooltip
                    title="ลบ"
                    color={"#31343A"}
                    key={"delete"}
                    placement="bottom"
                  >
                    <Button
                      shape="circle"
                      style={{ backgroundColor: "#FDE7E5", border: "none" }}
                      onClick={() => handleDeleteReccord(record)}
                    >
                      <DeleteFilled style={{ color: "#F04438" }} />
                    </Button>
                  </Tooltip>
                </Space>
              </>
            );
          }
        } else {
          return <></>;
        }
      }
    }
  ];

  const mergeColumns = canView
    ? columns
    : columns.filter(
        (v) => v.title === "ชื่อโครงการ" || v.dataIndex === "sequence"
      );

  return (
    <Content>
      <Card style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Table
          dataSource={dataSource}
          columns={mergeColumns}
          pagination={false}
          scroll={{ y: 300 }}
        />
      </Card>

      {canView === false && (
        <Button
          onClick={handleAdd}
          type="primary"
          style={{
            margin: "20px 0px 16px 0px",
            background: "#2E90FA",
            color: "#fff",
            fontWeight: 500
          }}
        >
          <PlusOutlined />
          เพิ่มโครงการ
        </Button>
      )}
    </Content>
  );
};

export default TableNameList;
